// extracted by mini-css-extract-plugin
export default {"backgroundVideoContainer":"backgroundVideo_backgroundVideoContainer__T7Anz","backgroundVideo":"backgroundVideo_backgroundVideo__V97hJ","mask":"backgroundVideo_mask__4hxqt"};